﻿// Constants only. All real data comes from the backend (see stockApi.js).
// The old random-number generators that lived here have been removed.

export const CHART_RANGES = ["1d", "1w", "3m", "6m", "ytd", "1yr", "5yr", "all"];

export const TRANSCRIPT_TYPES = ["All", "Earnings Calls", "Conferences", "Shareholder Meetings", "Guidance"];

export const FILING_FORMS = ["All", "10-K", "10-Q", "8-K", "DEF 14A", "4", "S-8"];
